/*
 *  This file is part of dalez/fluent-flarum
 *
 *  Copyright (c) 2025 DaleZ.
 *
 *  For detailed copyright and license information, please view the
 *  LICENSE-SCRIPT file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
let pool = app.cache.flunet_internal_pool = {};
export default pool;
flarum.reg.add('dalez-fluent-flarum', 'forum/viewTransition/cachePool', pool);